/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /**
   * =================================================================
   * CART DRAWER FIX - Ensures drawer opens on every add to cart
   * Also fixes variant selection tracking
   * =================================================================
   */
  
  // Wait for theme to fully initialize
  function initCartDrawerFix() {
    console.log('%c🔧 Cart Drawer Fix Initialized', 'background: #2ecc71; color: white; padding: 5px 10px; font-weight: bold;');

    // Fix 1: Open app's cart drawer after product is added
    // First refresh cart to get correct template, then open drawer
    document.addEventListener('theme:product:added', function(event) {
      console.log('%c✅ Product Added Event Caught', 'background: #27ae60; color: white; padding: 3px 6px;');
      
      // Small delay to ensure cart is updated first
      setTimeout(function() {
        const appDrawer = document.querySelector('[cart-drawer-wraper]');
        
        if (appDrawer) {
          // Update cart count in header
          updateCartCount();
          
          // Call refreshCart to reload drawer content with correct template (cart-item.liquid)
          if (typeof refreshCart === 'function') {
            console.log('%c🔄 Refreshing cart content...', 'background: #3498db; color: white; padding: 2px 5px;');
            refreshCart();
          }
          
          // Open drawer after a small delay for refresh to complete
          setTimeout(function() {
            appDrawer.classList.add('is-open');
            console.log('%c📂 App cart drawer opened', 'background: #16a085; color: white; padding: 2px 5px;');
          }, 200);
        } else {
          console.warn('App drawer [cart-drawer-wraper] not found');
        }
      }, 100);
    }, true);
    
    // Fix 1b: Update cart count in header after add-to-cart
    function updateCartCount() {
      fetch('/cart.js')
        .then(function(response) { return response.json(); })
        .then(function(cart) {
          const countElements = document.querySelectorAll('.header__cart__status');
          countElements.forEach(function(el) {
            el.textContent = cart.item_count;
            el.setAttribute('data-cart-count', cart.item_count);
          });
          console.log('%c🔢 Cart count updated:', 'background: #9b59b6; color: white; padding: 2px 5px;', cart.item_count);
        })
        .catch(function(error) {
          console.error('Error updating cart count:', error);
        });
    }
    
    // Fix 1c: Ensure cart toggle button works after drawer is closed
    // Use stopImmediatePropagation to prevent cart-drawer.js from double-toggling
    document.addEventListener('click', function(e) {
      const cartToggle = e.target.closest('[cart-toggle-btn], [data-cart-toggle]');
      if (!cartToggle) return;
      
      e.preventDefault();
      e.stopImmediatePropagation(); // Prevent other click handlers (cart-drawer.js) from running
      
      const appDrawer = document.querySelector('[cart-drawer-wraper]');
      if (appDrawer) {
        appDrawer.classList.toggle('is-open');
        console.log('%c🛒 Cart toggle clicked - drawer toggled', 'background: #f39c12; color: white; padding: 2px 5px;');
      }
    }, true); // Capture phase runs first

    // Fix 2: Intercept form submission and fix variant ID
    // v4 - Bulletproof: handles form-attribute-linked elements + protects FBT
    function fixVariantSelection() {
      console.log('%c🔧 Variant Fix v4 (Bulletproof)', 'background: #9b59b6; color: white; padding: 3px 6px;');
      
      // ✅ FIX: Temporarily neutralize Upsell inputs during MAIN product submission only
      // This prevents duplicate IDs while keeping Upsell form functional
      document.addEventListener('click', function(e) {
        var button = e.target.closest('[data-add-to-cart], button[name="add"]');
        if (!button) return;
        
        var form = button.closest('form');
        if (!form) return;
        
        var formId = form.getAttribute('id') || '';
        
        // Only neutralize Upsell inputs when MAIN product form is being submitted
        if (formId && formId.indexOf('Upsell') === -1) {
          console.log('🛡️ Main product Add to Cart - temporarily hiding Upsell inputs');
          
          // Find and temporarily neutralize Upsell inputs
          var upsellInputs = document.querySelectorAll('form[id*="Upsell"] input[name="id"]');
          upsellInputs.forEach(function(inp) {
            inp.setAttribute('data-temp-name', 'id');
            inp.removeAttribute('name');
          });
          
          // Restore after a short delay (after form submission)
          setTimeout(function() {
            upsellInputs.forEach(function(inp) {
              if (inp.hasAttribute('data-temp-name')) {
                inp.setAttribute('name', inp.getAttribute('data-temp-name'));
                inp.removeAttribute('data-temp-name');
              }
            });
            console.log('✅ Upsell inputs restored');
          }, 100);
        }
      }, true); // Capture phase
      
      // Cache for product data
      var productDataCache = {};
      
      // Pre-fetch product data on page load
      var productHandle = window.location.pathname.split('/products/')[1]?.split('?')[0];
      if (productHandle) {
        fetch('/products/' + productHandle + '.js')
          .then(function(r) { return r.json(); })
          .then(function(product) {
            productDataCache[productHandle] = product;
            console.log('%c📦 Product cached:', 'background: #3498db; color: white; padding: 2px 5px;', product.title, '(' + product.variants.length + ' variants)');
            product.variants.forEach(function(v) {
              console.log('   ', v.id, ':', v.title);
            });
            
            // ✅ SYNC MECHANISM: Only sync MAIN form <-> INSTALLMENT form (Shop Pay)
            // Find MAIN product form input
            var mainForm = document.querySelector('form.product-form[data-product-form]');
            var mainInput = mainForm ? mainForm.querySelector('input[name="id"]') : null;
            
            console.log('🔍 Main form:', mainForm);
            console.log('🔍 Main input:', mainInput, mainInput ? 'value=' + mainInput.value : '');
            
            // Find INSTALLMENT input - try multiple selectors
            var installmentInput = 
              document.querySelector('form.installment[data-product-form-installment] input[name="id"]') ||
              document.querySelector('form[id*="product-form-installment"] input[name="id"]') ||
              document.querySelector('.shop-pay-terms input[name="id"]');
            
            console.log('🔍 Shop Pay input:', installmentInput, installmentInput ? 'value=' + installmentInput.value : 'NOT FOUND');
            
            if (mainInput && installmentInput) {
              console.log('%c✅ Both inputs found - setting up AGGRESSIVE sync', 'background: #27ae60; color: white; padding: 3px 6px; font-weight: bold;');
              console.log('   Main input initial:', mainInput.value);
              console.log('   Shop Pay initial:', installmentInput.value);
              
              // AGGRESSIVE POLLING: Check every 50ms and sync
              setInterval(function() {
                var mainValue = mainInput.value;
                var shopPayValue = installmentInput.value;
                
                if (mainValue !== shopPayValue) {
                  console.log('%c🔄 SYNC! Main:', 'background: #f39c12; color: white; padding: 2px 5px;', mainValue, '→ Shop Pay was:', shopPayValue);
                  installmentInput.value = mainValue;
                  console.log('%c   ✓ Shop Pay NOW:', 'background: #27ae60; color: white; padding: 2px 5px;', installmentInput.value);
                }
              }, 50); // Check every 50ms
            } else {
              console.warn('%c⚠️ Could not find both inputs!', 'background: #e74c3c; color: white; padding: 3px 6px; font-weight: bold;');
              console.warn('   Main input:', mainInput ? 'FOUND' : 'NOT FOUND');
              console.warn('   Shop Pay input:', installmentInput ? 'FOUND' : 'NOT FOUND');
              
              // Retry after 1 second in case Shop Pay loads late
              setTimeout(function() {
                console.log('🔄 Retrying Shop Pay input detection...');
                var retryInstallmentInput = 
                  document.querySelector('form.installment[data-product-form-installment] input[name="id"]') ||
                  document.querySelector('form[id*="product-form-installment"] input[name="id"]') ||
                  document.querySelector('.shop-pay-terms input[name="id"]');
                
                if (mainInput && retryInstallmentInput) {
                  console.log('%c✅ Retry successful - setting up sync', 'background: #27ae60; color: white; padding: 3px 6px;');
                  // Set up the same sync logic
                  var observer = new MutationObserver(function() {
                    var newVariantId = mainInput.value;
                    if (retryInstallmentInput.value !== newVariantId) {
                      console.log('%c🔄 Syncing to Shop Pay:', 'background: #f39c12; color: white; padding: 2px 5px;', newVariantId);
                      retryInstallmentInput.value = newVariantId;
                    }
                  });
                  observer.observe(mainInput, { attributes: true, attributeFilter: ['value'] });
                  
                  var lastValue = mainInput.value;
                  setInterval(function() {
                    if (mainInput.value !== lastValue) {
                      lastValue = mainInput.value;
                      if (retryInstallmentInput.value !== lastValue) {
                        retryInstallmentInput.value = lastValue;
                      }
                    }
                  }, 100);
                } else {
                  console.error('❌ Retry failed - Shop Pay sync not available');
                }
              }, 1000);
            }
          });
      }
      
      // Helper: Get the checked value for a radio group by name + form attribute
      function getCheckedRadioValue(name, formAttr) {
        var selector;
        if (formAttr) {
          selector = 'input[type="radio"][form="' + formAttr + '"][name="' + CSS.escape(name) + '"]:checked';
        } else {
          selector = 'input[type="radio"][name="' + CSS.escape(name) + '"]:checked';
        }
        var checked = document.querySelector(selector);
        return checked ? checked.value : null;
      }
      
      // Intercept Add to Cart button clicks
      document.addEventListener('click', function(e) {
        var addButton = e.target.closest('button[type="submit"], button.btn--add-to-cart, [data-add-to-cart]');
        if (!addButton) return;
        
        var form = addButton.closest('form[action*="/cart/add"]') || addButton.closest('[data-product-form]');
        if (!form) return;
        
        var formId = form.getAttribute('id') || '';
        
        // Skip FBT/upsell forms - they have their own fixed variant IDs
        if (formId && (formId.indexOf('Upsell') !== -1 || formId.indexOf('FBT') !== -1) || form.closest('quick-add-product') || form.closest('.product-upsell')) {
          console.log('%c⏭️ Skipping FBT/Upsell form:', 'background: #95a5a6; color: white; padding: 2px 5px;', formId);
          return;
        }
        
        console.log('%c🛒 Add to Cart Clicked', 'background: #e74c3c; color: white; padding: 3px 6px;');
        console.log('   Form ID:', formId);
        
        // Find ALL variant radio buttons linked to this form via form attribute
        // These are OUTSIDE the <form> element but linked via form="formId" attribute
        var optionInputs = [];
        if (formId) {
          var linked = document.querySelectorAll('[form="' + formId + '"][data-single-option-selector]');
          linked.forEach(function(el) { optionInputs.push(el); });
        }
        // Also check inside form
        var inside = form.querySelectorAll('[data-single-option-selector]');
        inside.forEach(function(el) {
          if (optionInputs.indexOf(el) === -1) optionInputs.push(el);
        });
        
        console.log('   Option inputs found:', optionInputs.length);
        
        if (optionInputs.length === 0) {
          console.log('   No variant selectors - simple product');
          return;
        }
        
        // Collect unique option indices and their selected values
        var seenIndices = {};
        var selectedOptions = [];
        
        optionInputs.forEach(function(input) {
          var index = input.getAttribute('data-index'); // "option1", "option2", etc.
          if (!index || seenIndices[index]) return;
          seenIndices[index] = true;
          
          var value;
          if (input.type === 'radio') {
            // Get the CHECKED radio in this group
            value = getCheckedRadioValue(input.name, input.getAttribute('form'));
          } else {
            // Hidden input (dropdown/popout) - value is on the input directly
            value = input.value;
          }
          
          if (value) {
            console.log('   ' + index + ':', value);
          }
          
          // Store by index number for proper ordering
          var indexNum = parseInt(index.replace('option', ''));
          if (!isNaN(indexNum) && value) {
            while (selectedOptions.length < indexNum) selectedOptions.push(null);
            selectedOptions[indexNum - 1] = value;
          }
        });
        
        // Remove any null gaps
        selectedOptions = selectedOptions.filter(Boolean);
        console.log('   Selected:', JSON.stringify(selectedOptions));
        
        if (selectedOptions.length === 0) {
          console.log('   No checked options found');
          return;
        }
        
        // Get product data
        var handle = window.location.pathname.split('/products/')[1]?.split('?')[0];
        var product = productDataCache[handle];
        
        if (!product) {
          console.warn('   Product not cached:', handle);
          return;
        }
        
        // Find matching variant
        var matchingVariant = null;
        for (var i = 0; i < product.variants.length; i++) {
          var v = product.variants[i];
          var vOpts = [v.option1, v.option2, v.option3].filter(Boolean);
          
          if (vOpts.length !== selectedOptions.length) continue;
          
          var match = true;
          for (var j = 0; j < selectedOptions.length; j++) {
            if (vOpts[j] !== selectedOptions[j]) {
              match = false;
              break;
            }
          }
          if (match) {
            matchingVariant = v;
            break;
          }
        }
        
        if (!matchingVariant) {
          console.warn('   ❌ No variant match for:', selectedOptions);
          product.variants.forEach(function(v) {
            console.warn('     ', v.id, ':', [v.option1, v.option2, v.option3].filter(Boolean).join(' / '));
          });
          return;
        }
        
        console.log('%c✅ Matched:', 'background: #27ae60; color: white; padding: 2px 5px;', matchingVariant.id, '-', matchingVariant.title);
        
        // Update ALL input[name="id"] linked to this form
        // 1) Inside the form
        var idInputs = [];
        form.querySelectorAll('input[name="id"]').forEach(function(el) {
          idInputs.push(el);
        });
        // 2) Outside form but linked via form attribute
        if (formId) {
          document.querySelectorAll('input[name="id"][form="' + formId + '"]').forEach(function(el) {
            if (idInputs.indexOf(el) === -1) idInputs.push(el);
          });
        }
        
        console.log('   Found', idInputs.length, 'input[name="id"] elements');
        
        var fixed = false;
        idInputs.forEach(function(input, idx) {
          var currentVal = input.value;
          console.log('   input#' + idx + ': current=' + currentVal + ' (inside form: ' + form.contains(input) + ')');
          if (currentVal !== String(matchingVariant.id)) {
            input.value = matchingVariant.id;
            input.setAttribute('value', matchingVariant.id);
            console.log('%c   🔄 FIXED: ' + currentVal + ' → ' + matchingVariant.id, 'background: #e67e22; color: white; padding: 2px 5px;');
            fixed = true;
          }
        });
        
        if (!fixed) {
          console.log('   All IDs already correct');
        }
        
        if (idInputs.length === 0) {
          console.warn('   No input[name="id"] found! Adding one...');
          var newInput = document.createElement('input');
          newInput.type = 'hidden';
          newInput.name = 'id';
          newInput.value = matchingVariant.id;
          form.appendChild(newInput);
        }
      }, true); // Capture phase
    }

    // Initialize
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fixVariantSelection);
    } else {
      fixVariantSelection();
    }

    // Fix 3: Ensure event listeners persist after cart updates
    var originalGetCart = null;
    
    function patchCartGetMethod() {
      if (window.cart && window.cart.getCart && !originalGetCart) {
        originalGetCart = window.cart.getCart;
        window.cart.getCart = function() {
          var result = originalGetCart.apply(this, arguments);
          return result;
        };
        console.log('%c✅ cart.getCart() patched', 'background: #2980b9; color: white; padding: 2px 5px;');
      }
    }
    patchCartGetMethod();
    if (!window.cart) {
      var cartWaitInterval = setInterval(function() {
        if (window.cart) {
          clearInterval(cartWaitInterval);
          patchCartGetMethod();
        }
      }, 100);
    }
  }

  // Initialize the fix
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDrawerFix);
  } else {
    initCartDrawerFix();
  }

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

(function () {
  const CART_SELECTOR = '[cart-drawer-wraper]';

  let lockedY = 0;
  let isLocked = false;

  // store original inline styles so we can restore cleanly
  const originalBodyStyle = {
    position: '',
    top: '',
    width: '',
    overflow: '',
    overflowX: '',
    overflowY: '',
  };

  function cartEl() {
    return document.querySelector(CART_SELECTOR);
  }

  function isCartOpen() {
    return cartEl()?.classList.contains('is-open');
  }

  function isInsideCart(target) {
    return !!target?.closest?.(CART_SELECTOR);
  }

  function captureOriginalBodyInlineStyles() {
    const s = document.body.style;
    originalBodyStyle.position = s.position || '';
    originalBodyStyle.top = s.top || '';
    originalBodyStyle.width = s.width || '';
    originalBodyStyle.overflow = s.overflow || '';
    originalBodyStyle.overflowX = s.overflowX || '';
    originalBodyStyle.overflowY = s.overflowY || '';
  }

  function removeVendorFixedLock() {
    // 🔥 This is the main culprit that kills X
    const s = document.body.style;
    if (s.position === 'fixed') {
      s.position = '';
      s.top = '';
      s.width = '';
    }
    // also don’t force overflow here (we are not using overflow lock)
  }

  function restoreBodyInlineStyles() {
    const s = document.body.style;
    s.position = originalBodyStyle.position;
    s.top = originalBodyStyle.top;
    s.width = originalBodyStyle.width;
    s.overflow = originalBodyStyle.overflow;
    s.overflowX = originalBodyStyle.overflowX;
    s.overflowY = originalBodyStyle.overflowY;
  }

  function preventFocusScrollJump() {
    requestAnimationFrame(() => {
      document.activeElement?.blur();
      window.scrollTo(window.scrollX, lockedY);
    });
  }

  // Keep background Y fixed (X untouched)
  function holdBackgroundY() {
    if (!isLocked) return;
    if (window.scrollY !== lockedY) {
      window.scrollTo(window.scrollX, lockedY);
    }
  }

  // Block vertical wheel/touch ONLY when user is NOT interacting inside cart
  function onWheel(e) {
    if (!isLocked) return;
    if (isInsideCart(e.target)) return; // allow cart scrolling normally

    // If the intent is vertical scroll, block it; allow horizontal gestures
    if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
      e.preventDefault();
      window.scrollTo(window.scrollX, lockedY);
    }
  }

  let touchStartX = 0;
  let touchStartY = 0;

  function onTouchStart(e) {
    if (!isLocked) return;
    const t = e.touches?.[0];
    if (!t) return;
    touchStartX = t.clientX;
    touchStartY = t.clientY;
  }

  function onTouchMove(e) {
    if (!isLocked) return;
    if (isInsideCart(e.target)) return; // allow cart vertical scrolling

    const t = e.touches?.[0];
    if (!t) return;

    const dx = t.clientX - touchStartX;
    const dy = t.clientY - touchStartY;

    // block vertical swipe, allow horizontal swipe
    if (Math.abs(dy) > Math.abs(dx)) {
      e.preventDefault();
      window.scrollTo(window.scrollX, lockedY);
    }
  }

  function lockBackgroundYOnly() {
    if (isLocked) return;

    captureOriginalBodyInlineStyles();

    lockedY = window.scrollY;
    isLocked = true;

    // 🔥 remove vendor fixed lock so X keeps working
    removeVendorFixedLock();

    // keep background stuck on Y
    window.addEventListener('scroll', holdBackgroundY, { passive: true });

    // stop vertical wheel/touch ONLY outside cart
    window.addEventListener('wheel', onWheel, { passive: false });
    window.addEventListener('touchstart', onTouchStart, { passive: true });
    window.addEventListener('touchmove', onTouchMove, { passive: false });

    preventFocusScrollJump();
  }

  function unlockBackgroundYOnly() {
    if (!isLocked) return;
    isLocked = false;

    window.removeEventListener('scroll', holdBackgroundY);
    window.removeEventListener('wheel', onWheel);
    window.removeEventListener('touchstart', onTouchStart);
    window.removeEventListener('touchmove', onTouchMove);

    restoreBodyInlineStyles();
    window.scrollTo(window.scrollX, lockedY);
  }

  // Prevent browser focusing input inside cart and jumping page
  document.addEventListener('focusin', (e) => {
    if (isCartOpen() && isInsideCart(e.target)) {
      // allow focus if you want typing; but it can jump.
      // If you need typing, remove this blur line.
      e.target.blur();
    }
  });

  // Click hooks
  document.addEventListener('click', (event) => {
    const toggleBtn = event.target.closest('[cart-toggle-btn]');
    const closeBtn  = event.target.closest('[cart-drawer-close-btn]');

    // Toggle button handles BOTH open and close
    if (toggleBtn) {
      // wait a tick so theme toggles class first
      setTimeout(() => {
        if (isCartOpen()) {
          lockBackgroundYOnly();
        } else {
          unlockBackgroundYOnly();
        }
      }, 0);
      return;
    }

    // Close button still supported
    if (closeBtn) {
      setTimeout(() => {
        unlockBackgroundYOnly();
      }, 0);
    }
  });

  // Observe class changes (theme may open/close cart without your click handler)
  const cartWatcher = setInterval(() => {
    const cart = cartEl();
    if (!cart) return;
    clearInterval(cartWatcher);

    new MutationObserver(() => {
      if (isCartOpen()) lockBackgroundYOnly();
      else unlockBackgroundYOnly();
    }).observe(cart, { attributes: true, attributeFilter: ['class'] });
  }, 100);

  // Extra safety: vendor re-applies fixed position after AJAX refresh
  new MutationObserver(() => {
    if (isCartOpen()) {
      removeVendorFixedLock();
      holdBackgroundY();
    }
  }).observe(document.body, { attributes: true, attributeFilter: ['style'] });

})();